import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { ThemedText, ThemedView } from '@app/theme'
import ShieldCheckIcon from '@app/assets/svg/ShieldCheckIcon'

const SecureFetchBadge = () => {
    return (
        <ThemedView mt='md' borderRadius='sm' paddingVertical='sm' paddingHorizontal='md' backgroundColor='bg-fill-emphasis-secondary' flexDirection='row' alignItems='center'>
            <ShieldCheckIcon size={18} />
            <ThemedText ml='sm' color='text-secondary' variant='b4r'>Your bank accounts were securely fetched from MFCentral</ThemedText>
        </ThemedView>
    )
}

export default SecureFetchBadge

const styles = StyleSheet.create({})